import { setVid } from './chatFilterSetters';
const updateContactFilter = (filters, contact) => {
  return setVid(contact, filters);
};
export default updateContactFilter;